import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import Leaderboard from '../../components/Leaderboard';
import LeaderboardFooter from '../LeaderboardFooter';

import { useText } from 'common/hooks';

const deps = {
  leaderboard: state.challenge.visualisations.computedLeaderboardChallenge,
  organisationName: state.challenge.campaign.organisation.name,
  sectionTerm: state.challenge.campaign.sectionTerm,
};

function LeaderboardChallenge({
  leaderboard,
  organisationName,
  sectionTerm,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <>
      <Leaderboard
        title={t(`challenge.toplist.lists.challenge.you.${sectionTerm}`)}
        leaderboard={leaderboard.short}
      />
      <Leaderboard
        title={t(`challenge.toplist.lists.challenge.all.${sectionTerm}`, {
          organisationName,
        })}
        leaderboard={leaderboard.long}
      />
      <LeaderboardFooter
        currentPage={leaderboard.currentPage}
        pageCount={leaderboard.pageCount}
      />
    </>
  );
}

export default connect(deps, LeaderboardChallenge);
